import { Injectable, Optional } from "@angular/core";
import { DwActionHandler, DwModalService, DwMenuService, DwMetaDataGridActionState, DwActionResult, DwAction, DwActionType, DwModalConfig, DwImportMetaDataModalComponent, DwModalButtonStandardConfigs, DwGridActionResult, DwRoutingService, DwModalSize, ensureArray, DwMetaDataFormStateService, DwMetaDataFormApi, DwEventService, DwGridEvents, DwActionItemRequirement, DwMdFormActionHandler, DwMdFormActionState, DwWizardFinishService, DwWizardStateService } from "@devwareapps/devware-cap";
import { Observable, of } from "rxjs";
import { map, tap } from "rxjs/operators";
import { SchoolRepositoryService } from "../services/school-repository.service";
import { AppPermissions } from "../../../meta-data/app-permissions.enum";
import { AppMetaDataItemNames, FlightSchoolApplicantEntity } from "../../../meta-data/app-meta-data.service";

@DwAction({
    keyName: 'school-submit-applicant-action',
    display: 'School Submit Applicant',
    actionType: DwActionType.formAction,
    parentItemName: AppMetaDataItemNames.FlightSchoolApplicant,
    isGlobal: false,
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'Submit',
        iconClass: 'fa fa-share',
        buttonClass: 'btn btn-success',
        buttonTitle: 'Submit Applicant for Checkride scheduling'
    }
})
@Injectable()
export class SchoolSubmitApplicantActionService extends DwWizardFinishService {
    

     constructor(
        dwWizardStateService: DwWizardStateService,
        private dwRoutingService: DwRoutingService,
        private schoolRepository: SchoolRepositoryService
    ) {
        super(dwWizardStateService);
    }

    
    handleAction(actionState: DwMdFormActionState): Observable<DwActionResult> {



        return super.handleAction(actionState)
            .pipe(tap((result) => {
                if (result.success) {
                    const currentFlightSchoolInfo = this.schoolRepository.getCurrentPublicFlightSchool();

                    const applicant = actionState.formApi.getFormData() as FlightSchoolApplicantEntity;

                    this.schoolRepository.storeLastApplicant(applicant);

                    const url = `/school-portal/${currentFlightSchoolInfo?.PublicPortalSlug}?`;

                    this.dwRoutingService.navigateToUrl(url);
                }
            }));
    }
}